// extracted by mini-css-extract-plugin
export var button = "SubscriptionCancelled_button__vX2K3";
export var container = "SubscriptionCancelled_container__oMHej";
export var endDateDisclaimer = "SubscriptionCancelled_endDateDisclaimer__gQz3J";
export var info = "SubscriptionCancelled_info__gJeRO";
export var title = "SubscriptionCancelled_title__sVDy-";